"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GtmSnowplowEvent = void 0;
/**
 * Snowplow Events that will be also injected into the GTM Data layer
 */
var GtmSnowplowEvent;
(function (GtmSnowplowEvent) {
    GtmSnowplowEvent[GtmSnowplowEvent["PAGE_VIEW"] = 0] = "PAGE_VIEW";
    GtmSnowplowEvent[GtmSnowplowEvent["SR_SUBMIT"] = 1] = "SR_SUBMIT";
})(GtmSnowplowEvent || (exports.GtmSnowplowEvent = GtmSnowplowEvent = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvcGx1Z2lucy9jdXN0b20vZ29vZ2xlVGFnTWFuYWdlckRhdGFJbmplY3Rpb24vZW51bXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7O0dBRUc7QUFDSCxJQUFZLGdCQUdYO0FBSEQsV0FBWSxnQkFBZ0I7SUFDeEIsaUVBQVMsQ0FBQTtJQUNULGlFQUFTLENBQUE7QUFDYixDQUFDLEVBSFcsZ0JBQWdCLGdDQUFoQixnQkFBZ0IsUUFHM0IifQ==


// WEBPACK FOOTER //
// ../../../../../src/plugins/custom/googleTagManagerDataInjection/enums.ts